import BaseDTO from '../base/BaseDTO';
import PreviewDTO from './PreviewDTO';

export default class ContentDTO extends BaseDTO {
    public hash: string | undefined;
    public type: string | undefined;
    public cloudfrontUrl: string | undefined;
    public preview: PreviewDTO | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.hash = data['hash'] || undefined;
        this.type = data['type'] || undefined;
        this.cloudfrontUrl = data['cloudfrontUrl'] || undefined;
        this.preview = data['preview'] ? new PreviewDTO(data['preview']) : undefined;
    }
}
